import { render, staticRenderFns } from "./BucketList.vue?vue&type=template&id=7b213190&"
import script from "./BucketList.vue?vue&type=script&lang=js&"
export * from "./BucketList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports